import React from "react";
import Home from './Home';
import About from './About';
import Projects from './Projects';
import Cool from './Adventures';
// @ts-ignore
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Adventures from "./Adventures";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/adventures" element={<Adventures />} />
      </Routes>
    </BrowserRouter>
  );

}

export default App;